import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import login from '@/views/login.vue'
import index from '@/views/index.vue'
import error from '@/views/error.vue'
import share from '@/views/share.vue'
import program from "./views/program";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component:login
    },
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/product_list',
      name: 'product_list',
      component: ()=>import('@/views/product_list.vue'),
    },
    {
      path: '/product_detail',
      name: 'product_detail',
      component: ()=>import('@/views/product_detail.vue')
    },
    {
      path: '/add_goods_car',
      name: 'add_goods_car',
      component: ()=>import('@/views/add_goods_car.vue')
    },
    {
      path: '/my_goods_car',
      name: 'my_goods_car',
      component: ()=>import('@/views/my_goods_car.vue')
    },
    {
      path: '/settlement',
      name: 'settlement',
      component: ()=>import('@/views/settlement.vue')
    },
    {
      path: '/account_center',
      name: 'account_center',
      component: ()=>import('@/views/account_center.vue')
    },
    {
      path: '/custom_list',
      name: 'custom_list',
      component: ()=>import('@/views/custom_list.vue')
    },
    {
      path: '/custom_detail/:hash',
      name: 'custom_detail',
      component: ()=>import('@/views/custom_detail.vue')
    },
    {
      path: '/personal_center',
      name: 'personal_center',
      component: ()=>import('@/views/personal_center.vue'),
      children:[{
          path: '/personal_center/my_order',
          name: 'my_order',
          component: ()=>import('@/components/personal_center/my_order.vue'),
        },{
          path: '/personal_center/shipping_address',
          name: 'shipping_address',
          component: ()=>import('@/components/personal_center/shipping_address.vue'),
        },{
          path: '/personal_center/my_purse',
          name: 'my_purse',
          component: ()=>import('@/components/personal_center/my_purse.vue'),
      },
      ]
    },
    {
      path: '/home_page',
      component: ()=>import('@/views/HomePage.vue'),
      children: [
        {
          path: '',
          name: 'customer_solution',
          component: ()=>import('@/views/CustomerSolutionPage.vue'),
        },
        {
          path: 'solution',
          name: 'solution',
          component: ()=>import('@/views/SolutionConfiguration.vue'),
        },
        {
          path: 'plan',
          name: 'newPlan',
          component: ()=>import('@/views/NewPlanPage.vue'),
        },

      ]
    },
    {
      path: '/planDetail',
      name: 'planDetail',
      component: ()=>import('@/views/PlanInfoPage.vue'),
      children:[
        {
          path: 'basic/:project_hash/:scheme_hash',
          name: 'basic_info',
          component: () => import('@/views/BasicInfoPage')
        },
        {
          path: 'SolutionConfiguration/:project_hash/:scheme_hash',
          name: 'solution_configuration',
          component: () => import('@/views/PlanInfoView.vue')
        },
        {
          path: 'ProjectFilePage/:project_hash/:scheme_hash',
          name: 'project_filePage',
          component: () => import('@/views/ProjectFilePage')
        },
        {
          path: 'VipProjectFilePage/:project_hash/:scheme_hash',
          name: 'vip_project_filePage',
          component: () => import('@/views/VipProjectFilePage.vue')
        },
        {
          path: 'plan/:project_hash/:scheme_hash',
          name: 'detailNewPlan',
          component: ()=>import('@/views/NewPlanPage.vue'),
        },
        {
          path: 'vip_c_file/:project_hash/:scheme_hash',
          name: 'vipTerminalFilewPage',
          component: ()=>import('@/views/VipTerminalFilePage.vue'),
        },
      ]
    },
    {
      path: '/error',
      name: 'error',
      component:error
    },
    {
      path: '/share',
      name: 'share',
      component:share
    },
    {
      path: '/program',
      name: 'program',
      component:program
    },

  ]
})

// 前置全局路由守卫
router.beforeEach((to, from, next) => {
  if(to.path=='/login' || to.path=='/error' || to.path=='/share' || to.path=='/program'){
    next();
    return;
  }
  if(store.getters.get_userInfo.utoken){
    next()
    window.scrollTo(0, 0);
    document.documentElement.scrollTo(0,0)
  }else {
    next('/login')
  }
})
router.afterEach(()=>{
  window.scrollTo(0, 0)
})
export default router
